<div *ngIf="visible" class="toast-container" [ngClass]="[state.toLowerCase(), inline ? 'toast-inline' : '']">
  <div class="toast-icon">
    <app-svg-icon [icon]="iconName" [color]="iconColor" [size]="24"></app-svg-icon>
  </div>
  <div class="toast-body">
    <span class="toast-title" *ngIf="validationTitle">{{ validationTitle }}</span>
    <span class="toast-message" *ngIf="!htmlMessage">{{ validationMessage }}</span>
    <span class="toast-message" *ngIf="htmlMessage" [innerHTML]="safeHtmlMessage"></span>
    <ng-content></ng-content>
    <button *ngIf="actionText" class="toast-action-link" (click)="action.emit()">{{ actionText }}</button>
  </div>
  <button *ngIf="!inline || closable" class="toast-close" (click)="closeToast()">
    <app-svg-icon icon="cancel" color="#363636" [size]="16"></app-svg-icon>
  </button>
  <div *ngIf="!inline && !persistent" class="toast-countdown" [style.animation-duration]="displayTime + 'ms'"></div>
</div>
